// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserSection_wrapper__1uJOo","p":"UserSection_p__8yb3v"};